module.exports = __webpack_public_path__ + "assets/img/weibo.493b4bca.png";